<div class="no-data-container">
  <img class="product-img" src="/assets/e-commerce/icons/65.webp" />
  <p class="no-data-text">
    {{ "No addresses" | transloco }}
  </p>
  <button class="btn btn-add" routerLink="/addaddress" style="margin-bottom: 10px;">
    {{ "Add Address" | transloco }}
  </button>
</div>